import { render, staticRenderFns } from "./DmhMessage.vue?vue&type=template&id=0791d6bb"
import script from "./DmhMessage.vue?vue&type=script&lang=js"
export * from "./DmhMessage.vue?vue&type=script&lang=js"
import style0 from "./DmhMessage.vue?vue&type=style&index=0&id=0791d6bb&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports